/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
/**
 * Register a new sidebar section inside the files sharing sidebar tab.
 *
 * @param section - The section to register
 */
export function registerSidebarSection(section) {
    if (!section.id) {
        throw new Error('Sidebar sections must have an id');
    }
    if (!section.element || !section.element.startsWith('oca_') || !window.customElements.get(section.element)) {
        throw new Error('Sidebar sections must provide a registered custom web component identifier');
    }
    if (typeof section.order !== 'number') {
        throw new Error('Sidebar sections must have the order property');
    }
    if (typeof section.enabled !== 'function') {
        throw new Error('Sidebar sections must implement the enabled method');
    }
    window._nc_files_sharing_sidebar_sections ??= new Map();
    if (window._nc_files_sharing_sidebar_sections.has(section.id)) {
        throw new Error(`Sidebar section with id "${section.id}" is already registered`);
    }
    window._nc_files_sharing_sidebar_sections.set(section.id, section);
}
/**
 * Get all registered sidebar sections for the files sharing sidebar tab.
 */
export function getSidebarSections() {
    return [...(window._nc_files_sharing_sidebar_sections?.values() ?? [])];
}
